module.exports = __webpack_public_path__ + "assets/media/evening.222cd552.mp3";